import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Chart, StockChart } from 'angular-highcharts';
import { Subject } from 'rxjs';
import { CommonService, PlantServiceService } from 'src/app/services/index';
import {
  Highcharts$ as Highcharts,
  Highcharts$,
  IrradianceGraphTypeEnum
} from 'src/app/shared/index';
import { SolarParametersModel } from '../../../../../models/solar-configuration.model';
@Component({
  selector: 'app-power-irradiance',
  templateUrl: './power-irradiance.component.html',
  styleUrls: ['./power-irradiance.component.scss']
})
export class PowerIrradianceComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  graphTypes = [
    // {value: ['irradiance', 'ac_power'], viewValue: 'Irradiance Vs AC Power'},
    // {value: ['ac_power', 'dc_power'], viewValue: 'AC Power Vs DC Power'},
    // {value: ['ac_power'], viewValue: 'AC Power'}
    { value: 0, viewValue: 'Irradiance Vs AC Power' },
    { value: 1, viewValue: 'AC Power Vs DC Power' },
    { value: 2, viewValue: 'AC Power' }
  ];
  isShowTotal = true;
  fromDate = '';
  toDate = '';
  value = 0;
  stock: StockChart;
  // stock: Chart;
  chart: Chart;
  irradiancechart: Chart;
  graphTypeSelected = IrradianceGraphTypeEnum.IrradianceVsACPower;
  title = 'Irradiance Vs AC Power';
  data = { irradiance: [], ac_power: [], dc_power: [] };
  date = new UntypedFormControl(new Date());
  solarDataTrendChartToExcel = { irradiance: [], ac_power: [], dc_power: [] };
  icon = true;
  max = new Date();
  isNotViewFull = true;
  buttons: any;
  siteId: string;
  processNameRids: any;
  @Input() resizeSubscription: Subject<any>;
  constructor(
    private plantService: PlantServiceService,
    private datePipe: DatePipe,
    private http: HttpClient,
    private commonService: CommonService
  ) {
    // this.onInitIrradianceChart(this.data);
  }

  ngOnInit() {
    const self = this;
    this.plantService.getSolarConfigSubject().subscribe((solarConfig) => {
      this.siteId = solarConfig.siteId;
      this.processNameRids = solarConfig.processNameRids;
      self.getSolarDataTrend();
    });
  }
  ngOnChanges() {}
  getSolarDataTrend() {
    const dateSelected = this.transformDate();
    const pamrameters = this.transformGraphType(); // ['irradiance', 'ac_power']; // ;
    // Object.assign({}, this.processNameRids); // {'Solar HT': '#49:49', 'Solar Admin': '#567:43'};
    const model = new SolarParametersModel(
      this.siteId,
      this.processNameRids,
      dateSelected,
      pamrameters
    );
    // this.irradiancechart.destroy();
    // this.onInitIrradianceChart(null);
    this.plantService.getSolarDataTrend(model).subscribe((data) => {
      // this.irradiancechart.destroy();
      this.solarDataTrendChartToExcel = data;
      this.onInitIrradianceChart(data);
    });
  }

  ngAfterViewInit() {
    const seft = this;
    this.resizeSubscription.subscribe((event) => {
      this.onResize(event);
    });

    this.buttons = Highcharts$.getOptions().exporting.buttons;
    Highcharts$.setOptions({
      exporting: {
        buttons: {
          contextButton: {
            menuItems: this.buttons.contextButton.menuItems.slice(0, 2)
          }
        }
      }
    });
    document.addEventListener('fullscreenchange', function () {
      if (seft.irradiancechart && seft.irradiancechart.ref) {
        seft.irradiancechart.ref.update({
          exporting: {
            buttons: {
              contextButton: {
                menuItems: seft.isNotViewFull
                  ? seft.buttons.contextButton.menuItems.slice(1, 2)
                  : seft.buttons.contextButton.menuItems.slice(0, 2)
              }
            }
          }
        });
      }
      seft.isNotViewFull = !seft.isNotViewFull;
    });
  }
  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', function () {});
  }
  onResize(event) {
    const seft = this;

    const dom = document.getElementById('chartContainer');
    if (seft.commonService.isNullOrUndefined(dom)) {
      return;
    }
    if (dom && dom.clientHeight > 400) {
      setTimeout(() => {
        dom.setAttribute('height', '400');
      }, 200);
    }
    if (document.fullscreenElement) {
      seft.irradiancechart.ref.setSize(
        document.documentElement.clientWidth,
        document.documentElement.clientHeight
      );
    } else {
      seft.irradiancechart.ref.setSize(
        dom.clientWidth,
        dom.clientHeight < 200 ? dom.clientHeight : 200
      );
    }
  }
  onGraphTypeChange() {
    this.getSolarDataTrend();
    this.isShowTotal =
      this.graphTypeSelected === IrradianceGraphTypeEnum.IrradianceVsACPower;
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    // this.events.push(`${type}: ${event.value}`);
    this.getSolarDataTrend();
  }
  transformDate() {
    if (this.date !== undefined && this.date !== null && this.date.valid) {
      return this.datePipe.transform(this.date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  transformGraphType() {
    switch (this.graphTypeSelected) {
      case IrradianceGraphTypeEnum.IrradianceVsACPower: {
        return ['irradiance', 'ac_power'];
      }
      case IrradianceGraphTypeEnum.ACPowerVsDCPower: {
        return ['ac_power', 'dc_power'];
      }
      default: {
        return ['ac_power'];
      }
    }
  }
  calTotalIrradiation(data: any) {
    if (data !== undefined && data !== null && data.length > 0) {
      let sumIrradiation = 0;
      for (let i = 0; i < data.length; i++) {
        sumIrradiation += data[i].y;
      }
      this.fromDate = this.datePipe.transform(data[0].x, 'yyyy-MM-dd hh:mm:ss');
      this.toDate = this.datePipe.transform(
        data[data.length - 1].x,
        'yyyy-MM-dd hh:mm:ss'
      );
      this.value = sumIrradiation / (60 * 1000);
    }
  }
  onInitIrradianceChart(data: any) {
    const result = this.getYAxisGraphType(data);
    const option = {
      chart: {
        // type: 'line',
        zoomType: 'x',
        height: 200
      },
      title: {
        text: this.title
      },
      credits: {
        enabled: false
      },
      navigator: {
        enabled: true
      },
      // xAxis: {
      //   type: 'datetime',
      //   dateTimeLabelFormats: {
      //     minute: '%H:%M',
      //   },
      //   title: {
      //       text: 'Time'
      //   }
      // },
      xAxis: {
        type: 'datetime',
        labels: {
          autoRotation: [-45],
          formatter: function () {
            return Highcharts.dateFormat('%H:%M', this.value);
          }
        },
        crosshair: true
      },
      yAxis: result.yAxis,
      series: result.series,
      legend: {
        enabled: true
      },
      tooltip: {
        // headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        // pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        // '<td style="padding:0"><b>{point.y:.3f} kWh</b></td></tr>',
        // footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        series: {
          showInLegend: true,
          turboThreshold: 1500
        }
      }
      // exporting: {
      //   enabled: true,
      //   buttons: {
      //     contextButton: {
      //       menuItems: []
      //       }
      //     }
      // }
    };
    // const self = this;
    // const menuItems = (<any>Highcharts.getOptions().exporting).buttons.contextButton.menuItems.slice();
    //   // this.irradiancechart.ref.options.exporting.buttons.contextButton.menuItems.push(...button);
    //   menuItems.push(...[{text: 'Export to Excel',
    //   onclick: function() {
    //     return self.exportSolarDataTrendChart();
    //    }}]);
    // option.exporting.buttons.contextButton.menuItems = menuItems;
    this.irradiancechart = new Chart(<any>option);
    // this.irradiancechart.ref.options.exporting.buttons.contextButton.menuItems.push(...button);
  }
  getYAxisGraphType(data: any) {
    let yAxis = null;
    let series = null;
    if (data !== undefined && data !== null) {
      switch (this.graphTypeSelected) {
        case IrradianceGraphTypeEnum.IrradianceVsACPower: {
          this.title = 'Irradiance Vs AC Power';
          yAxis = [
            {
              // Primary yAxis
              labels: {
                format: '{value} kW',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              title: {
                text: 'AC Power kW',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              opposite: false
            },
            {
              // Secondary yAxis
              title: {
                text: 'Irradiance W/m2',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              labels: {
                format: '{value} W/m2',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              opposite: true
            }
          ];
          series = [
            {
              name: 'AC Power',
              type: 'spline',
              yAxis: 0,
              data: data.ac_power,
              tooltip: {
                valueSuffix: ' kW'
              }
            },
            {
              name: 'Irradiance',
              type: 'spline',
              yAxis: 1,
              data: data.irradiance,
              tooltip: {
                valueSuffix: ' W/m2'
              }
            }
          ];
          this.calTotalIrradiation(data.irradiance);
          break;
        }
        case IrradianceGraphTypeEnum.ACPowerVsDCPower: {
          this.title = 'AC Power Vs DC Power';
          yAxis = [
            {
              // Primary yAxis
              labels: {
                format: '{value} kW',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              title: {
                text: 'AC Power kW',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              opposite: false
            },
            {
              // Secondary yAxis
              title: {
                text: 'DC Power kW',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              labels: {
                format: '{value} kW',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              opposite: true
            }
          ];
          series = [
            {
              name: 'AC Power',
              type: 'spline',
              yAxis: 0,
              data: data.ac_power,
              tooltip: {
                valueSuffix: ' kW'
              }
            },
            {
              name: 'DC Power',
              type: 'spline',
              yAxis: 1,
              data: data.dc_power,
              tooltip: {
                valueSuffix: ' kW'
              }
            }
          ];
          break;
        }
        default: {
          // AC Power
          this.title = 'AC Power';
          yAxis = [
            {
              // Primary yAxis
              labels: {
                format: '{value} kW',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              title: {
                text: 'Power kW',
                style: {
                  color: Highcharts.getOptions().colors[0]
                }
              },
              opposite: false
            }
          ];
          series = [
            {
              name: 'AC Power',
              type: 'spline',
              yAxis: 0,
              data: data.ac_power,
              tooltip: {
                valueSuffix: ' kW'
              }
            }
          ];
          break;
        }
      }
    }
    return { yAxis: yAxis, series: series };
  }

  private exportSolarDataTrendChart = () => {
    let chartData = {};
    const xAxis = [];
    let yAxis = ['irradiance', 'ac_power', 'dc_power'];
    const data = {};
    const exportToExcel = () => {
      for (let i = 0; i < yAxis.length; i++) {
        const y = yAxis[i];
        const itemSolar = this.solarDataTrendChartToExcel[y];
        for (let j = 0; j < itemSolar.length; j++) {
          const itemData = itemSolar[j];
          // check if itemData.x existed in xAxis or not. If not, push.
          if (xAxis.indexOf(itemData.x) === -1) {
            xAxis.push(itemData.x);
          }
        }
      }
      xAxis.sort(function (a, b) {
        return a - b;
      });
      for (let j = 0; j < xAxis.length; j++) {
        xAxis[j] = this.datePipe.transform(xAxis[j], 'yyyy-MM-dd hh:mm:ss');
        const x = xAxis[j];
        const objData = {};
        for (let k = 0; k < yAxis.length; k++) {
          const y = yAxis[k];
          const dataSolar = this.solarDataTrendChartToExcel[y];
          for (let i = 0; i < dataSolar.length; i++) {
            dataSolar[i].x = this.datePipe.transform(
              dataSolar[i].x,
              'yyyy-MM-dd hh:mm:ss'
            );
            if (dataSolar[i].x === x) {
              objData[y] = dataSolar[i].y;
              break;
            }
          }
        }
        data[x] = objData;
      }
      chartData = { xAxis: xAxis, yAxis: yAxis, data: data };
    };
    switch (this.graphTypeSelected) {
      case IrradianceGraphTypeEnum.IrradianceVsACPower: {
        yAxis = ['irradiance', 'ac_power'];
        exportToExcel();
        this.exportChartDataToExcel(
          chartData,
          'IrradianceVsACPowerChartData.xlsx'
        );
        break;
      }
      case IrradianceGraphTypeEnum.ACPowerVsDCPower: {
        yAxis = ['ac_power', 'dc_power'];
        exportToExcel();
        this.exportChartDataToExcel(
          chartData,
          'ACPowerVsDCPowerChartData.xlsx'
        );
        break;
      }
      default: {
        // AC Power - Nothing
        break;
      }
    }
  };
  private exportChartDataToExcel = (chartData: any, fileName: string) => {};
  public click = (solarYieldExpansionPanel: MatExpansionPanel, $event: any) => {
    $event.stopPropagation();
    if ($event && $event.target && $event.target.className) {
      if (
        Array.isArray($event.target.className) &&
        $event.target.className.includes('arrow-expansion-panel-customize')
      ) {
        if ($event.target.className.includes('desc')) {
          solarYieldExpansionPanel.open();
        } else {
          solarYieldExpansionPanel.close();
        }
        this.icon = !this.icon;
      } else {
        this.icon
          ? solarYieldExpansionPanel.open()
          : solarYieldExpansionPanel.close();
      }
    }
  };
}
